import { Grid, Typography } from "@mui/material";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { UsersTable } from "Users/Components/UsersTable";
import { UsersTable2 } from "Users/Components/UsersTable2";

export const DashboardPage: React.FunctionComponent = () => {
	return (
		<AuthenticatedLayout title="Dashboard">
			<Typography variant="h1">Dashboard</Typography>

			<Grid container gap={1} justifyContent="space-between">
				<Grid item xs={5}>
					<UsersTable />
				</Grid>

				<Grid item xs={6}>
					<UsersTable2 />
				</Grid>
			</Grid>
		</AuthenticatedLayout>
	);
};
